import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux';
import { AppDispatch, RootState, store } from '../../redux-stores/store';
import instagramPlatformLogo from "../../assets/images/platforms/platform-instagram.png"
import youtubePlatformLogo from "../../assets/images/platforms/platform-youtube.png"
import { addSocialAccount } from '../../services/api/influencer';
import { toast } from 'react-toastify';
import { toggleAddSocialAccountModal } from '../../redux-stores/slices/layoutSlice';
import { getErrorMessage } from '../../utils/helpers';
import { fetchInfluencer } from '../../redux-stores/slices/influencerSlice';
import { useSelector } from 'react-redux';
import { analyticsLog } from '../../lib/analytics';

const platformLogos = {
    ig: instagramPlatformLogo,
    yt: youtubePlatformLogo
};

const AddSocialAccount: React.FC<{platforms: {id: string, name: string}[]}> = ({platforms}) => {
    const [loading, setLoading] = React.useState(false);
    const dispatch = useDispatch<AppDispatch>();
    const [errors, setErrors] = useState<{ platform?: string, handle?: string }>({});
    const socialAccounts = useSelector((state: RootState) => state.influencer.social_accounts);
    const maxSocialAccountsConfig = useSelector((state: RootState) => state.auth?.configurations?.max_social_accounts || {});

    const availablePlatforms = platforms.filter(platform => {
        const maxForPlatform = maxSocialAccountsConfig[platform.id] || 1;
        const currentCountForPlatform = socialAccounts.filter((account) => account.social_account.platform === platform.id).length;
        
        return currentCountForPlatform < maxForPlatform;
    });

    const [data, setData] = useState<{ platform: string, handle: string }>({ platform: availablePlatforms.length === 0 ? '' : (availablePlatforms.length === 1 ? availablePlatforms[0].id : 'ig'), handle: '' });

    const validateForm = () => {
        let newErrors: { platform?: string, handle?: string } = {};
        if (!data.platform) {
            newErrors.platform = "Please select a social media platform.";
        }
        if (!data.handle) {
            newErrors.handle = "Please enter your social media handle or profile link.";
        }
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    }

    const handleSubmit = async (e: any) => {
        e.preventDefault();
        if (!validateForm()) return;
        try {
            setLoading(true);
            await addSocialAccount(data)
            analyticsLog('social_account_link_success', data);
            const token = store.getState().auth.token;
            if(token){
                dispatch(fetchInfluencer(token));
            }
            toast.success("Social account added successfully.");
            dispatch(toggleAddSocialAccountModal({active: false}));
        } catch (error: any) {
            analyticsLog('social_account_link_failed', {...data, error: error?.response?.data?.error_code ?? getErrorMessage(error)});
            console.error(error);
            toast.error(getErrorMessage(error) || "Failed to add social account. Please try again.");
        } finally {
            setLoading(false);
        }
    }
    return (
        <form onSubmit={handleSubmit}>
            <div className="d-flex flex-column gap-075">
                <h4 className="new-slide-up-modal-heading mt-2 mb-0">Add Social Account</h4>
                <span className="new-slide-up-modal-desc">
                    Add your social media account to connect with brands.
                </span>
            </div>
            <div className="mt-4 profile-inputs">
                <div className="form-group">
                    <label htmlFor="platform">Platform</label>
                    <div className="radio-tile-group">
                        {
                            availablePlatforms.map((platform) => (
                                <div key={platform.id} className={`radio-tile cursor-pointer ${data.platform === platform.id ? 'active' : ''}`} onClick={() => setData({ ...data, platform: platform.id })}>
                                    <img className='h-100' src={platformLogos[platform.id as keyof typeof platformLogos]} />
                                </div>
                            ))
                        }
                    </div>
                    {errors.platform && <div className="text-danger font-12 mt-1">{errors.platform}</div>}
                </div>
                <div className="form-group">
                    <label htmlFor="platform">Handle/Profile Link</label>
                    <input value={data.handle}
                        onBlur={validateForm}
                        onChange={(e) => {
                            setData({ ...data, handle: e.target.value });
                        }} type="text" className="form-control profile-input-form-control" id="handle" name="handle" placeholder="Enter your social media handle or profile link" />
                    {errors.handle && <div className="text-danger font-12 mt-1">{errors.handle}</div>}
                </div>
            </div>

            {/* Save Changes Button */}
            <div className="campaign-apply-ig-connect-benefit-actions pb-5">
                <button disabled={loading} type="submit" className="new-ui-btn">{loading ? 'Saving...' : 'Save'}</button>
            </div>
        </form >
    )
}

export default AddSocialAccount
